export const getLayerConstraints = (layer: any) => ({
  horizontal: layer.constraints.horizontal,
  vertical: layer.constraints.vertical,
});
